import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fc2ed2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = {
  key: 0,
  class: "profile-info d-flex align-items-center"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center bg-primary rounded me-3 me-md-0",
  style: {"display":"block","height":"85px","width":"85px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-search text-white p-2",
  style: {"font-size":"50px","line-height":"1"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "title mt-12 mt-sm-0" }
const _hoisted_9 = {
  key: 0,
  class: "text-black fw-medium mb-8"
}
const _hoisted_10 = {
  key: 1,
  class: "placeholder-glow mb-8"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-12" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-10 placeholder-lg" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "d-flex mt-2 fs-md-20 text-muted"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon ph-bold ph-linkedin-logo" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon ph-fill ph-twitter-logo" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon ph-bold ph-facebook-logo" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder-glow" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-6" })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-11\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-12\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-11\" data-v-6fc2ed2b></span></h5>", 3)
const _hoisted_34 = [
  _hoisted_31
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-5 mb-5 mt-sm-10 mb-sm-10 mt-md-15 mb-md-5 mt-lg-30 mb-lg-30" }, null, -1))
const _hoisted_36 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_37 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_38 = { class: "icon text-dark rounded-circle text-center" }
const _hoisted_39 = {
  key: 0,
  class: "flaticon-map"
}
const _hoisted_40 = {
  key: 1,
  class: "flaticon-mail"
}
const _hoisted_41 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_42 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-black rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-taget" })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Alignment Score", -1))
const _hoisted_45 = {
  key: 2,
  class: "position-relative"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-mail" })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Draft a Pass Email ", -1))
const _hoisted_48 = {
  key: 3,
  class: "position-relative"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-secondary rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-brainstorm" })
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Next Step Prediction", -1))
const _hoisted_51 = {
  key: 4,
  class: "position-relative"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen" })
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "1st Look Memo", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-medium text-black-emphasis mb-0" }, "Company Information")
], -1))
const _hoisted_56 = {
  key: 3,
  class: "info mt-25 ps-0 mb-0 list-unstyled"
}
const _hoisted_57 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info" })
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Reputation Risks ", -1))
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" })
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Stage", -1))
const _hoisted_64 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-dark" }, "Currently Raising", -1))
const _hoisted_66 = {
  key: 2,
  class: "position-relative"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-money" })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Total Raised (per crunchbase) ", -1))
const _hoisted_69 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_70 = {
  key: 3,
  class: "position-relative"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-money" })
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Funding Rounds (per crunchbase) ", -1))
const _hoisted_73 = { key: 3 }
const _hoisted_74 = {
  key: 4,
  class: "position-relative"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-status" })
], -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Segments ", -1))
const _hoisted_77 = {
  key: 0,
  class: "badge rounded-pill text-outline-info me-1 mb-1"
}
const _hoisted_78 = {
  key: 5,
  class: "position-relative"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" })
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Business Model ", -1))
const _hoisted_81 = {
  key: 6,
  class: "position-relative"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-price-tag-1" })
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Product Type(s)", -1))
const _hoisted_84 = {
  key: 0,
  class: "badge rounded-pill text-outline-info me-1 mb-1"
}
const _hoisted_85 = {
  key: 7,
  class: "position-relative"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-credit-card" })
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Revenue Model(s)", -1))
const _hoisted_88 = {
  key: 0,
  class: "badge rounded-pill text-outline-info me-1 mb-1"
}
const _hoisted_89 = {
  key: 8,
  class: "position-relative"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-shopping-cart-2" })
], -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Target Audience ", -1))
const _hoisted_92 = {
  key: 9,
  class: "position-relative"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" })
], -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Year Started", -1))
const _hoisted_95 = {
  key: 10,
  class: "position-relative"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-maps-and-flags" })
], -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Head Quartered", -1))
const _hoisted_98 = {
  key: 11,
  class: "position-relative"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-mail-inbox-app" })
], -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Email", -1))
const _hoisted_101 = ["href"]
const _hoisted_102 = {
  key: 12,
  class: "position-relative"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-telephone-call" })
], -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Phone No", -1))
const _hoisted_105 = ["href"]
const _hoisted_106 = {
  key: 13,
  class: "position-relative"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-web" })
], -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Website", -1))
const _hoisted_109 = ["href"]
const _hoisted_110 = {
  key: 14,
  class: "position-relative"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-dark rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date-1" })
], -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Report Updated ", -1))
const _hoisted_113 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_114 = { key: 4 }
const _hoisted_115 = /*#__PURE__*/_createStaticVNode("<ul class=\"mt-25 ps-0 mb-0 list-unstyled\" data-v-6fc2ed2b><li class=\"mb-25\" data-v-6fc2ed2b><h3 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-6\" data-v-6fc2ed2b></span></h3><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-10\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-8\" data-v-6fc2ed2b></span></h5></li><li class=\"mb-25\" data-v-6fc2ed2b><h3 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-8\" data-v-6fc2ed2b></span></h3><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-11\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-5\" data-v-6fc2ed2b></span></h5></li><li class=\"mb-25\" data-v-6fc2ed2b><h3 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-6\" data-v-6fc2ed2b></span></h3><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-9\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-10\" data-v-6fc2ed2b></span></h5></li><li class=\"mb-25\" data-v-6fc2ed2b><h3 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-7\" data-v-6fc2ed2b></span></h3><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-12\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-5\" data-v-6fc2ed2b></span></h5></li><li class=\"mb-25\" data-v-6fc2ed2b><h3 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-10\" data-v-6fc2ed2b></span></h3><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-7\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-9\" data-v-6fc2ed2b></span></h5></li><li class=\"mb-25\" data-v-6fc2ed2b><h3 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-7\" data-v-6fc2ed2b></span></h3><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-10\" data-v-6fc2ed2b></span></h5><h5 class=\"placeholder-glow\" data-v-6fc2ed2b><span class=\"placeholder col-9\" data-v-6fc2ed2b></span></h5></li></ul>", 1)
const _hoisted_116 = [
  _hoisted_115
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdateActions = _resolveComponent("UpdateActions")!
  const _component_AlignmentScore = _resolveComponent("AlignmentScore")!
  const _component_PredictedOutcome = _resolveComponent("PredictedOutcome")!
  const _component_PassModal = _resolveComponent("PassModal")!
  const _component_MemoModal = _resolveComponent("MemoModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.company_research_data && _ctx.company_research_data.INFO)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_ctx.company?.logo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.company.logo,
                    class: "rounded border p-2 me-3 me-md-0",
                    alt: "Logo",
                    style: {"max-height":"85px","max-width":"85px"}
                  }, null, 8, _hoisted_7)),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.company.name)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_9, _toDisplayString(_ctx.company.name), 1))
                  : (_openBlock(), _createElementBlock("h5", _hoisted_10, _hoisted_12)),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.company.gap_closing_category && _ctx.company.gap_closing_category.AVG.title)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goToTab', 'gci', 'averaged_gap_analysis'))),
                        class: _normalizeClass({
              'badge rounded-pill fs-13 me-1 mb-1 cursor-pointer': true,
              'text-bg-secondary': _ctx.company.gap_closing_category.AVG.title.toLowerCase().includes('neutral') == true,
              'text-bg-success': _ctx.company.gap_closing_category.AVG.title.toLowerCase().includes('closing') == true,
              'text-bg-warning': _ctx.company.gap_closing_category.AVG.title.toLowerCase().includes('widening') == true,
            })
                      }, _toDisplayString(_ctx.company.gap_closing_category.AVG.title), 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
                ]),
                (_ctx.company_research_data && _ctx.company_research_data.INFO)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_ctx.company_research_data.INFO.linkedin_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.company_research_data.INFO.linkedin_url,
                            target: "_blank",
                            class: "mr-2 text-decoration-none"
                          }, _hoisted_20, 8, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_ctx.company_research_data.INFO.twitter_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.company_research_data.INFO.twitter_url,
                            target: "_blank",
                            class: "mr-2 text-decoration-none"
                          }, _hoisted_23, 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      (_ctx.company_research_data.INFO.facebook_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: _ctx.company_research_data.INFO.facebook_url,
                            target: "_blank",
                            class: "mr-2 text-decoration-none"
                          }, _hoisted_26, 8, _hoisted_24))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_34)),
        (((_ctx.company?.in_thesis != null && _ctx.company.gap_closing_category.AVG.score) || (_ctx.canAccessFeature('inboundList') && _ctx.company?.status)) && _ctx.company_research_data && _ctx.company_research_data.INFO)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_35,
              _createElementVNode("ul", _hoisted_36, [
                (_ctx.canAccessFeature('inboundList') && _ctx.company?.status && _ctx.company?.will_use_status_feature !== null)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        (_ctx.company?.will_use_status_feature)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_39))
                          : (_openBlock(), _createElementBlock("i", _hoisted_40))
                      ]),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.company?.will_use_status_feature ? 'Status' : 'Send Pass'), 1),
                      _createVNode(_component_UpdateActions, {
                        ref: "updateActionsRef",
                        "initial-status": _ctx.company.status,
                        "status-reason": _ctx.company.status_reason,
                        id: _ctx.company.id,
                        "use-status-feature": _ctx.company.will_use_status_feature,
                        onUpdateStatus: _ctx.handleUpdateStatus,
                        "select-class": 'pt-2 pb-2'
                      }, null, 8, ["initial-status", "status-reason", "id", "use-status-feature", "onUpdateStatus"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.company?.in_thesis != null && _ctx.company.gap_closing_category.AVG.score)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                      _hoisted_43,
                      _hoisted_44,
                      _createVNode(_component_AlignmentScore, {
                        inThesis: _ctx.company.in_thesis,
                        customAnswers: _ctx.company.customAnswers,
                        gapClosingScore: _ctx.company.gap_closing_category.AVG.score,
                        reputationFlags: _ctx.company.reputation_risks?.flags,
                        softFailedFilters: _ctx.company.thesis_failed_filters?.soft_fails,
                        hardFailedFilters: _ctx.company.thesis_failed_filters?.hard_fails
                      }, null, 8, ["inThesis", "customAnswers", "gapClosingScore", "reputationFlags", "softFailedFilters", "hardFailedFilters"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.canAccessFeature('inboundList') && _ctx.company?.status == null)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                      _hoisted_46,
                      _hoisted_47,
                      _createElementVNode("button", {
                        class: "btn btn-outline-primary btn-sm",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.passModalAction = true)),
                        style: {"--bs-btn-padding-y":".25rem","--bs-btn-padding-x":".5rem","--bs-btn-font-size":".75rem"}
                      }, " Click to Draft Pass Email ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.company?.in_thesis != null && _ctx.company.gap_closing_category.AVG.score && _ctx.company?.status)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                      _hoisted_49,
                      _hoisted_50,
                      _createVNode(_component_PredictedOutcome, {
                        fullText: true,
                        inThesis: _ctx.company.in_thesis,
                        gapClosingScore: _ctx.company.gap_closing_category.AVG.score,
                        status: _ctx.company.status,
                        reputationFlags: _ctx.company.reputation_risks?.flags,
                        customAnswers: _ctx.company?.customAnswers,
                        softFailedFilters: _ctx.company.thesis_failed_filters?.soft_fails,
                        hardFailedFilters: _ctx.company.thesis_failed_filters?.hard_fails,
                        hasActiveFailures: _ctx.company.has_active_failures
                      }, null, 8, ["inThesis", "gapClosingScore", "status", "reputationFlags", "customAnswers", "softFailedFilters", "hardFailedFilters", "hasActiveFailures"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.company?.in_thesis != null && _ctx.company.gap_closing_category.AVG.score)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                      _hoisted_52,
                      _hoisted_53,
                      _createElementVNode("p", null, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.memoModalAction = true)),
                          style: {"--bs-btn-padding-y":".25rem","--bs-btn-padding-x":".5rem","--bs-btn-font-size":".75rem"}
                        }, "Click to Draft 1st Look Memo")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_54,
        _hoisted_55,
        (_ctx.company_research_data && _ctx.company_research_data.INFO)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_56, [
              (_ctx.company.reputation_risks && _ctx.company.reputation_risks.flags && _ctx.company.reputation_risks.flags?.length > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                    _hoisted_58,
                    _hoisted_59,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.reputation_risks.flags, (flag, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (_ctx.flagMap[flag])
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "text-bg-warning badge me-1 mb-1 cursor-pointer",
                              onClick: ($event: any) => (_ctx.$emit('goToTab', 'company', _ctx.flagMap[flag].report))
                            }, _toDisplayString(_ctx.flagMap[flag].label), 9, _hoisted_60))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data && _ctx.company_research_data.INFO && _ctx.company_research_data.INFO.stage)
                ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
                    _hoisted_62,
                    _hoisted_63,
                    _createElementVNode("span", _hoisted_64, [
                      _createTextVNode(_toDisplayString(_ctx.company_research_data.INFO.stage) + " ", 1),
                      (_ctx.company_research_data.INFO.is_currently_raising)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" and is "),
                            _hoisted_65
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data.INFO && _ctx.company_research_data.INFO.total_funding_raised != 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
                    _hoisted_67,
                    _hoisted_68,
                    _createElementVNode("span", _hoisted_69, _toDisplayString('$' + _ctx.company_research_data.INFO.total_funding_raised.replace(/\.\d+/,
          '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.funding_rounds && _ctx.company.funding_rounds.length > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_70, [
                    _hoisted_71,
                    _hoisted_72,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.funding_rounds, (funding_round, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (funding_round.funding_type)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(funding_round.funding_type) + " ", 1),
                              (funding_round.announced_date)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" (" + _toDisplayString(new Date(funding_round.announced_date).toLocaleString('default', { month: 'long', year: 'numeric' })) + "): ", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (funding_round.money_raised)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString('$' + funding_round.money_raised.replace(/\.\d+/,
                    '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (funding_round.number_of_investor)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (funding_round.money_raised)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" - ")
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(funding_round.number_of_investor) + " Investors ", 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (index < _ctx.company.funding_rounds.length - 1)
                          ? (_openBlock(), _createElementBlock("br", _hoisted_73))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.tags)
                ? (_openBlock(), _createElementBlock("li", _hoisted_74, [
                    _hoisted_75,
                    _hoisted_76,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.raw_data[0].raw_json.tags, (value, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        value
                          ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(key), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.sales_strategies)
                ? (_openBlock(), _createElementBlock("li", _hoisted_78, [
                    _hoisted_79,
                    _hoisted_80,
                    _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.sales_strategies.business_type) + " (" + _toDisplayString(_ctx.company.raw_data[0].raw_json.sales_strategies.purchasers) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.product_types && _ctx.hasActiveProductTypes)
                ? (_openBlock(), _createElementBlock("li", _hoisted_81, [
                    _hoisted_82,
                    _hoisted_83,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.raw_data[0].raw_json.product_types, (value, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        value
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(key), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.revenue_models && _ctx.hasActiveRevenueModels)
                ? (_openBlock(), _createElementBlock("li", _hoisted_85, [
                    _hoisted_86,
                    _hoisted_87,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.raw_data[0].raw_json.revenue_models, (value, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        value
                          ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(key), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.sales_strategies.target_audience)
                ? (_openBlock(), _createElementBlock("li", _hoisted_89, [
                    _hoisted_90,
                    _hoisted_91,
                    _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.sales_strategies.target_audience), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data.INFO.founding_year)
                ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                    _hoisted_93,
                    _hoisted_94,
                    _createTextVNode(" " + _toDisplayString(_ctx.company_research_data.INFO.founding_year), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data.INFO.hq)
                ? (_openBlock(), _createElementBlock("li", _hoisted_95, [
                    _hoisted_96,
                    _hoisted_97,
                    (_ctx.company_research_data.INFO.hq.address)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.company_research_data.INFO.hq.address) + ", ", 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.company_research_data.INFO.hq.city)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.company_research_data.INFO.hq.city), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.company_research_data.INFO.hq.state)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(", " + _toDisplayString(_ctx.company_research_data.INFO.hq.state), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.company_research_data.INFO.hq.country)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(", " + _toDisplayString(_ctx.company_research_data.INFO.hq.country), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data.INFO.contact_email)
                ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                    _hoisted_99,
                    _hoisted_100,
                    _createElementVNode("a", {
                      href: 'mailto:' + _ctx.company_research_data.INFO.contact_email,
                      class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                    }, _toDisplayString(_ctx.company_research_data.INFO.contact_email), 9, _hoisted_101)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data.INFO.contact_phone_number)
                ? (_openBlock(), _createElementBlock("li", _hoisted_102, [
                    _hoisted_103,
                    _hoisted_104,
                    _createElementVNode("a", {
                      href: 'tel:' + _ctx.company_research_data.INFO.contact_phone_number,
                      class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                    }, _toDisplayString(_ctx.company_research_data.INFO.contact_phone_number), 9, _hoisted_105)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.website)
                ? (_openBlock(), _createElementBlock("li", _hoisted_106, [
                    _hoisted_107,
                    _hoisted_108,
                    _createElementVNode("a", {
                      href: _ctx.company.website,
                      target: "_blank",
                      class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                    }, _toDisplayString(_ctx.company.website), 9, _hoisted_109)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company_research_data.INFO.updated_at)
                ? (_openBlock(), _createElementBlock("li", _hoisted_110, [
                    _hoisted_111,
                    _hoisted_112,
                    _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.formatTimeAgo( _ctx.company_research_data.INFO.updated_at)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_114, _hoisted_116))
      ])
    ]),
    (_ctx.company.id && _ctx.company.name)
      ? (_openBlock(), _createBlock(_component_PassModal, {
          key: 0,
          modelValue: _ctx.passModalAction,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passModalAction) = $event)),
          "company-id": Number(_ctx.company.id),
          "company-name": _ctx.company.name,
          "email-address": _ctx.company.inbound_reply_to_email,
          "recipient-name": _ctx.company.inbound_reply_to_name,
          "is-actions-enabled": _ctx.isActionsEnabled,
          onUpdateStatus: _ctx.updateCompanyStatus
        }, null, 8, ["modelValue", "company-id", "company-name", "email-address", "recipient-name", "is-actions-enabled", "onUpdateStatus"]))
      : _createCommentVNode("", true),
    (_ctx.company.id && _ctx.company.name)
      ? (_openBlock(), _createBlock(_component_MemoModal, {
          key: 1,
          modelValue: _ctx.memoModalAction,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memoModalAction) = $event)),
          "company-id": Number(_ctx.company.id)
        }, null, 8, ["modelValue", "company-id"]))
      : _createCommentVNode("", true)
  ], 64))
}